export default "__VITE_ASSET__58525495__$_?nuxt_component=async&nuxt_component_name=SvgoHelp2955394__"